import appReducer from './reducers'
import thunk from 'redux-thunk'
import {applyMiddleware, createStore} from 'redux'

const consoleMessages = store => next => action => {

    let result;

    console.groupCollapsed(`dispatching action => ${action.type}`);
    console.log('Old Game State', store.getState());

    result = next(action);

    console.log('New Game State', store.getState());
    console.groupEnd();

    return result

};

export default (initialState = {}) => {
    return applyMiddleware(thunk, consoleMessages)(createStore)(appReducer, initialState/*, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()*/)
}